import { environment } from "@repo/ui";

import { type TabOptions } from "./types";

export const predefinedTabs: TabOptions[] = [
  {
    label: "label.workspace",
    tabPanelId: "WORKSPACE_TAB",
    url: "/saleslead/workspace/",
    configKey: "enable_workspace",
  },
  {
    label: environment.isProd ? "label.projects" : "berries",
    tabPanelId: "PROJECTS_TAB",
    url: "/saleslead/",
    configKey: "enable_saleslead",
  },
  {
    label: "label.b2b_opportunities",
    tabPanelId: "OPPORTUNITIES",
    url: "/bas/leads/",
    configKey: "enable_B2BOpportunities",
  },
  {
    label: "label.b2b_customers",
    tabPanelId: "B2B_TAB",
    url: "/bas/business-customers/",
    configKey: "enable_B2BCustomers",
  },
  {
    label: "label.brm",
    tabPanelId: "BRM_TAB",
    url: "/brm/",
    configKey: "enable_BRM",
  },
  {
    label: "Apples",
    tabPanelId: "APPLES_TAB",
    url: "/saleslead/apples/",
    configKey: "enable_apples",
  },
  {
    label: "Bananas",
    tabPanelId: "BANANAS_TAB",
    url: "/saleslead/bananas/",
    configKey: "enable_bananas",
  },
];
